import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useFileUpload } from '@/lib/upload/useFileUpload.ts';
import templateImagesApi from '@/features/dashboard/templateImages/api/templateImagesApi.ts';
import { templateImagesApiQueryKeys } from '@/features/dashboard/templateImages/api/templateImagesApi.queryKeys.ts';

// Two-step presigned upload (init → PUT to GCS → confirm). The resulting
// `downloadUrl` is read from the media-library list (refetched on success),
// since the dedicated download-url endpoint returns text/plain which the
// fetch wrapper would discard.
export default function useUploadTemplateImage() {
  const queryClient = useQueryClient();

  return useFileUpload<{ fileId: string }>({
    initUpload: (request) => templateImagesApi.initUpload(request),
    processUpload: async (fileId: string) => {
      await templateImagesApi.confirmUpload(fileId);
      return { fileId };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: templateImagesApiQueryKeys.all(),
      });
    },
    onError: (error: Error) => {
      toast.error('Błąd przesyłania', {
        description:
          error.message || 'Wystąpił błąd podczas przesyłania grafiki.',
      });
    },
  });
}
